module.exports = __webpack_public_path__ + "./fonts/SofiaPro-Regular.otf";